import React, { lazy } from 'react';
import { Route, useRouteMatch, Switch } from 'react-router-dom';

const SucursalesView = lazy(() => import('../../container/administracion/sucursales/Index'));
const SucursalesForm = lazy(() => import('../../container/administracion/sucursales/Form'));
const UnidadesMedicas = lazy(() => import('../../container/administracion/sucursales/UnidadesMedicas'));

const SucursalesRoute = () => {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}/sucursales/listado`} component={SucursalesView} />
      <Route path={`${path}/sucursales/agregar`} component={SucursalesForm} />
      <Route exact path={`${path}/sucursales/editar/:id`} component={SucursalesForm} />
      <Route exact path={`${path}/sucursales/unidades-medicas/:id/:nombre`} component={UnidadesMedicas} />
    </Switch>
  );
};

export default SucursalesRoute;

